import { ThemeConfig } from 'antd';

const theme: ThemeConfig = {
  token: {
    fontFamily: 'JLRBody',
  },
  components: {
    Button: {
      colorPrimary: '#263238',
      colorPrimaryHover: '#263238',
    },
    Input: {
      colorBorderSecondary: '#263238',
      borderRadius: 2,
    },
    DatePicker: {
      colorBorderSecondary: '#263238',
      borderRadius: 2,
    },
    Tabs: {
      colorPrimary: '#263238',
    },
    Radio: {
      colorPrimary: '#263238',
      radioSize: 17,
      dotSize: 8,
      colorBorder: '#B9A2E2',
    },
    Checkbox: {
      colorPrimary: '#263238',
      colorBorder: '#B9A2E2',
      colorPrimaryHover: '#263238',
    },
  },
};

export default theme;
